module.exports = __webpack_public_path__ + "static/img/2.bf5ee12.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/5/2/sp/2.png
// module id = elq8
// module chunks = 0